<template>
  <div>
    <PageTitle title="Summary" />
    <b-container fluid>
      <b-row>
        <b-col xs="12" md="5" xl="7" class="mb-3">
          <b-row>
            <b-col xs="12" xl="6" class="mb-3">
              <Card title="Source" class="fill-height" no-body>
                <SourceSummary />
              </Card>
            </b-col>

            <b-col xs="12" xl="6" class="mb-3">
              <Card title="Queries" class="fill-height" no-body>
                <ReadSummary />
              </Card>
            </b-col>
          </b-row>

          <b-row>
            <b-col xs="12" xl="6" class="mb-3">
              <Card title="Transform" class="fill-height" no-body>
                <TransformSummary />
              </Card>
            </b-col>

            <b-col xs="12" xl="6" class="mb-3">
              <Card title="Target" class="fill-height" no-body>
                <TargetSummary />
              </Card>
            </b-col>
          </b-row>
        </b-col>

        <b-col xs="12" md="7" xl="5">
          <Card title="Run Log">
            <pre ref="log" class="log">{{ responseLogWithMessage }}</pre>
            <b-progress
              v-if="migrationLoading"
              variant="primary"
              striped
              animated
              class="mt-2"
            >
              <b-progress-bar :value="100">
                Running Migration...
              </b-progress-bar>
            </b-progress>
            <b-alert v-show="taskCreated" show variant="info">
              <h6>Task Created</h6>

              <p>
                An import task is running,
                <router-link to="/tasks">click here</router-link> to view.
              </p>
            </b-alert>
            <template v-slot:footer>
              <Button
                v-if="!responseLog.length || migrationLoading"
                class="mr-2"
                variant="success"
                :loading="migrationLoading"
                @click="runMigration"
              >
                Run Migration
              </Button>
              <Button
                v-if="responseLog.length && !migrationLoading"
                class="mr-2"
                @click="clearResponseLog"
              >
                Clear Log
              </Button>
              <Button
                v-if="responseLog.length && !migrationLoading"
                @click="downloadLog"
              >
                Download Log
              </Button>
            </template>
          </Card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters, mapState } from 'vuex';

import { downloadFile } from '@/utils';
import store from '@/plugins/vuex';
import Card from '@/components/Card.vue';
import Button from '@/components/Button.vue';
import PageTitle from '@/components/PageTitle.vue';
import ReadSummary from '@/components/summary/ReadSummary.vue';
import SourceSummary from '@/components/summary/SourceSummary.vue';
import TargetSummary from '@/components/summary/TargetSummary.vue';
import TransformSummary from '@/components/summary/TransformSummary.vue';

export default defineComponent({
  name: 'Summary',
  components: {
    Button,
    Card,
    PageTitle,
    ReadSummary,
    SourceSummary,
    TargetSummary,
    TransformSummary,
  },
  data() {
    return {
      file: undefined,
      taskCreated: false,
    };
  },
  // created() { },
  computed: {
    ...mapState({
      migrationLoading: (state: any) => state.migration.migrationLoading,
    }),
    ...mapGetters({
      source: 'source/config',
      transform: 'transform/config',
      target: 'target/config',
      responseLog: 'migration/responseLog',
    }),
    responseLogWithMessage(): string {
      const log = JSON.stringify(this.responseLog, null, 2);
      if (this.responseLog.length && !this.migrationLoading) {
        return log + '\n\n Clear the log to run migration';
      } else {
        return log;
      }
    },
  },
  methods: {
    jsonString(value: string) {
      return JSON.stringify(value, null, 2);
    },
    async runMigration() {
      await store.dispatch.migration.runMigration(null);
      store.dispatch.task.loadList();
    },
    clearResponseLog() {
      store.dispatch.migration.clearResponseLog(null);
    },
    downloadLog() {
      const content = JSON.stringify(this.responseLog);
      downloadFile(content, {
        name: `migration-log-${new Date().toISOString()}.json`,
        type: 'application/json',
      });
    },
  },
  watch: {
    responseLog() {
      const log = this.$refs.log as any;
      this.$nextTick(() => {
        log.scrollTop = log.scrollHeight;
      });
    },
    migrationLoading(val, oldVal) {
      if (
        this.target.link &&
        !this.taskCreated &&
        !val &&
        oldVal &&
        this.responseLog.length
      ) {
        this.taskCreated = true;
      }
    },
  },
});
</script>
<style scoped>
.wrapped {
  white-space: pre-wrap;
}
.log {
  max-height: 500px;
  overflow-y: scroll;
}
</style>
